import React from "react";
import styled from "styled-components";
import {TypeOfItem} from "../../types";

const DoubleContainer = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'isDrag',
})<{size: number; square: number}>`
    position: relative;
    width: ${({size}) => size}px;
    height: ${({size}) => size}px;
`;

const Absolute = styled.div<{top: number; left: number}>`
    top: ${({top}) => top}px;
    left: ${({left}) => left}px;
    position: absolute;
`;

interface Props {
    size: number;
    count: number;
    component: ({size, typeOfItem}: { size: number; typeOfItem: TypeOfItem }) => JSX.Element;
    typeOfItem: TypeOfItem;
    square?: number;
    isDrag?: boolean;
}

export const BaseItemSquare = ({size, count, component: Component, typeOfItem, square = 2, isDrag}: Props) => {
    const DOUBLE = <>
        <Absolute top={0} left={0}>
            <Component typeOfItem={typeOfItem} size={size} />
        </Absolute>
        <Absolute top={0} left={size}>
            <Component typeOfItem={typeOfItem} size={size} />
        </Absolute>
        <Absolute top={size} left={0}>
            <Component typeOfItem={typeOfItem} size={size} />
        </Absolute>
        <Absolute top={size} left={size}>
            <Component typeOfItem={typeOfItem} size={size} />
        </Absolute>
    </>

    const TRIPLE = <>
        <Absolute top={0} left={size * -1}>
            <Component typeOfItem={typeOfItem} size={size} />
        </Absolute>
        <Absolute top={0} left={0}>
            <Component typeOfItem={typeOfItem} size={size} />
        </Absolute>
        <Absolute top={0} left={size}>
            <Component typeOfItem={typeOfItem} size={size} />
        </Absolute>

        <Absolute top={size} left={size * -1}>
            <Component typeOfItem={typeOfItem} size={size} />
        </Absolute>
        <Absolute top={size} left={0}>
            <Component typeOfItem={typeOfItem} size={size} />
        </Absolute>
        <Absolute top={size} left={size}>
            <Component typeOfItem={typeOfItem} size={size} />
        </Absolute>

        <Absolute top={size * 2} left={size * -1}>
            <Component typeOfItem={typeOfItem} size={size} />
        </Absolute>
        <Absolute top={size * 2} left={0}>
            <Component typeOfItem={typeOfItem} size={size} />
        </Absolute>
        <Absolute top={size * 2} left={size}>
            <Component typeOfItem={typeOfItem} size={size} />
        </Absolute>
    </>


    return (
        <DoubleContainer square={square} size={size}>
            {count < 6 ? DOUBLE : TRIPLE}
        </DoubleContainer>
    )
}
